<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">库存管理&nbsp;/&nbsp;</span>
      </div>
      <div>出入库记录</div>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <div class="member-header">
            <div class="flex-row ml10">
                <v-date @time="changeDate"></v-date>
            </div>
            <div>
              <el-select v-model="query.billCategoryId" placeholder="全部类型" filterable @change="selectChange" class="ml10">
                <el-option
                  v-for="item in option1"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-button type="primary" @click="searchDoQuery" class="ml30">搜索</el-button>
          </div>
          <div class="plr16">
            <el-table :data="list" :max-height="height - 265" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="billCategoryName" width="auto" label="类型"></el-table-column>
              <el-table-column prop="billNo" width="auto" label="单据号"></el-table-column>
              <el-table-column prop="createTime" label="制单时间" width="170px">
                <template slot-scope="scope">{{ formatDate(scope.row.createTime) }}</template>
              </el-table-column>
              <el-table-column prop="createName" width="auto" label="制单人员"></el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                    <el-link type="primary" @click="leaveRequest(scope.row)">详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <edit-set ref="editSetForm" @change="handleChange"></edit-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import editSet from "./edit";
export default {
  data() {
    return {
      url: this.$url.inventoryBillInfo.list,
      query: {
        beginTime: new Date(),
        endTime: new Date(),
        billCategoryId: "",
        start: 0,
        size: 20
      },
      height: this.$store.getters.MainHeight,
      option1: [
          {
            text: "全部类型",
            value: ""
          },
      ],
      list: []
    };
  },
  mixins: [minxin],
  components: { editSet },
  computed: {},

  created() {
    this.query.reportMonth = new Date();
    this.getType();
    this.totalCounts();
  },

  methods: {
    back() {
      this.$router.push("/dataList/inventory");
    },
    getType() {
      this.$api.post(this.$url.inventoryStorageInfo.pullDownList).then(res => {
        if (res) {
          let arr = [];
          res.map(item => {
            arr.push({text: item.name,value: item.id});
          })
          this.option1 = this.option1.concat(arr);
        }
      });
    },
    changeDate(value) {
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
    },
    leaveRequest(row) {
      this.$refs["editSetForm"].$emit("set", row);
    },
    handleChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    searchDoQuery() {
      this.query.start = 0;
      this.totalCounts();
    },
    selectChange() {
      this.query.start = 0;
      this.totalCounts();
    },
    totalCounts () {
      this.$api.post(this.$url.inventoryBillInfo.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  height: calc(100% - 72px);
  .member-content-box {
    background: #fff;
  }
  .member-header {
    
    padding: 16px;
    display: flex;
  }
}
</style>

